import { IAction } from "../../../../interface/action.interface";
import { ISublistDto } from "../../interface/dto/sublist.dto";

export enum SublistActionType {
    SUBLIST_GET = "SUBLIST_GET",
    SUBLIST_GET_SUCCESS = "SUBLIST_GET_SUCCESS",
    SUBLIST_GET_ERROR = "SUBLIST_GET_ERROR",
}

export interface ISublistGetAction extends IAction {
    type: SublistActionType.SUBLIST_GET;
    payload: {
        listId: number;
    };
}

export interface ISublistGetSuccessAction extends IAction {
    type: SublistActionType.SUBLIST_GET_SUCCESS;
    payload: {
        sublist: Array<ISublistDto>;
    };
}

export interface ISublistGetErrorAction extends IAction {
    type: SublistActionType.SUBLIST_GET_ERROR;
    payload: {
        error: string;
    };
}

export const sublistGetAction = (listId: number): ISublistGetAction => ({
    type: SublistActionType.SUBLIST_GET,
    payload: {
        listId,
    },
});

export const sublistGetSuccessAction = (
    sublist: Array<ISublistDto>,
): ISublistGetSuccessAction => ({
    type: SublistActionType.SUBLIST_GET_SUCCESS,
    payload: { sublist },
});

export const sublistGetErrorAction = (error: string) => ({
    type: SublistActionType.SUBLIST_GET_ERROR,
    payload: { error },
});

export type ISublistAction =
    | ISublistGetAction
    | ISublistGetSuccessAction
    | ISublistGetErrorAction;
